import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: "EnrolmentExportModal"
}
const _hoisted_2 = { class: "EnrolmentExportModalContentBlock" }
const _hoisted_3 = {
  key: 0,
  class: "ContentContainerExport"
}
const _hoisted_4 = ["id", "value"]
const _hoisted_5 = ["for"]
const _hoisted_6 = {
  key: 1,
  class: "ContentContainerExport"
}
const _hoisted_7 = { class: "ModalExportTitle" }
const _hoisted_8 = { class: "ExportPreview" }
const _hoisted_9 = ["value", "checked", "onChange"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "WarningContainer"
}
const _hoisted_12 = {
  key: 2,
  class: "WarningContainer WarningNoExportContent"
}
const _hoisted_13 = { class: "ExportButtonsContainer" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "EnrolmentExportModalHeaderBlock" }, [
      _createElementVNode("h3", null, "Export to CSV")
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.exportOptions.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("h6", { class: "ModalExportTitle" }, " Please select the type of export: ", -1 /* CACHED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exportOptions, (exportOption, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: exportOption.name
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "exportOption",
                  id: `exportOption-${index.toString()}`,
                  value: exportOption,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedExportOption) = $event)),
                  class: "RadioButton"
                }, null, 8 /* PROPS */, _hoisted_4), [
                  [_vModelRadio, _ctx.selectedExportOption]
                ]),
                _createElementVNode("label", {
                  for: `exportOption-${index.toString()}`,
                  class: "RadioButtonLabel"
                }, _toDisplayString(exportOption.label), 9 /* TEXT, PROPS */, _hoisted_5)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h6", _hoisted_7, " You are about to export the " + _toDisplayString(_ctx.textPresenter.amountOfEnrolmentsDisplayText) + " that are currently visible on your screen. ", 1 /* TEXT */)
          ])),
      _createElementVNode("div", _hoisted_8, [
        _cache[4] || (_cache[4] = _createElementVNode("p", null, [
          _createElementVNode("i", { class: "lnr-flag InfoIcon" }),
          _createTextVNode("Selected export contains:")
        ], -1 /* CACHED */)),
        _createElementVNode("p", null, _toDisplayString(_ctx.selectedExportOption.headerString), 1 /* TEXT */)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableCsvSeparators, (separator) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([
					'ExportTypeWrapper',
					_ctx.isLearnMoreToggled(separator.name) ? 'LearnMoreToggled' : ''
				])
        }, [
          _createElementVNode("label", null, [
            _createElementVNode("input", {
              type: "radio",
              name: "exportType",
              value: separator.name,
              checked: _ctx.isSeparatorSelected(separator.name),
              onChange: ($event: any) => (_ctx.updateSelectedCsvSeparator(separator.name))
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_9),
            _createTextVNode(" " + _toDisplayString(separator.title), 1 /* TEXT */)
          ]),
          _createElementVNode("i", {
            class: "lnr-info ToggleLearnMoreButton",
            onClick: ($event: any) => (_ctx.toggleLearnMore(separator.name))
          }, null, 8 /* PROPS */, _hoisted_10),
          (_ctx.isLearnMoreToggled(separator.name))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "lnr-notification-circle WarningIcon" }, null, -1 /* CACHED */)),
                _createTextVNode(" " + _toDisplayString(separator.description), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      }), 256 /* UNKEYED_FRAGMENT */)),
      (_ctx.csvExportEmpty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "lnr-notification-circle WarningIcon" }, null, -1 /* CACHED */),
            _createTextVNode(" Your selected export has no content. Please change your filters or type of export. ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          class: "ExitButton CancelButton",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onExportCanceled()))
        }, " Cancel "),
        _createElementVNode("button", {
          class: "DriverButton PrimaryButton DownloadButton",
          disabled: !_ctx.selectedExportOption || _ctx.csvExportEmpty,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onExportDownloaded()))
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("i", { class: "lnr-download2 ButtonIcon" }, null, -1 /* CACHED */),
          _createTextVNode(" Download ", -1 /* CACHED */)
        ]))], 8 /* PROPS */, _hoisted_14)
      ])
    ])
  ], 512 /* NEED_PATCH */))
}